export default {
    list: [],
    model: {},
    children: [],
    total: 0,
    page: 1,
}
